// ADR 25.9.26f §2 — the tutor FAB's fold, for the frame that draws before the
// wasm has arrived.
//
// `rust-core/src/entitlement/tutor.rs` owns the decision; this is its
// TypeScript twin, one of the two `portsRetired.test.ts` sanctions (AC11).
// Both the nav (`layout/nav/destinations.ts`) and the FAB render in the first
// frame, so neither may reach the facade. `fabState.test.ts` replays every
// `tutor_fab_state` row of `golden/entitlement_table.json` against it (AC3).
//
// **Branch order is the decision**, as in Rust: the flag first, then signed-in,
// then paid.

import type { TutorFabState } from '../../../wasm'

/** What may the tutor button be, for this user, right now? */
export function tutorFabState(
  isSignedIn: boolean,
  hasPaidAccess: boolean,
  tutorEnabled: boolean,
): TutorFabState {
  if (!tutorEnabled || !isSignedIn) return 'hidden'
  return hasPaidAccess ? 'available' : 'locked_upgrade'
}
